module.exports = __webpack_public_path__ + "static/woonkameroverzicht-ac64a37d5489dc627b45c4990f97e89e.jpg";